<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :impuestos="impuestos"
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :proveedor="proveedor"
          :filtroFechaDocumentos="filtroFechaDocumentos"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card :header="titulo">
          <b-table hover
              responsive="sm" 
              :class="tableClass"
              :busy="tableBusy"
              :items="pagos" 
              :fields="pagosFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(fechaContable)="data">
              {{ data.item.fechaContable | fecha }}
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(saldo)="data">
              {{ data.item.saldo | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>{{ labelAnular }}</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div> -->

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Orden de Pago</b-dropdown-item>
          <b-dropdown-item @click.stop="exportarListado">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Órdenes</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'pagos/getField',
  mutationType: 'pagos/updateField',
});

export default {
  name: 'Pagos',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  props: {
    impuestos: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      pagosFields: [
        // { 
        //   key: 'id',
        //   label: 'Nro.Orden',
        //   class: 'text-right'
        // },
        { 
          key: 'numero',
          label: 'Nro.Orden',
          class: 'text-right'
        },
        { key: 'fechaRegistro' },
        { key: 'fechaContable' },
        { key: 'proveedor' },
        {
          key: 'total',
          class: 'text-right'
        },
        {
          key: 'saldo',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'pagos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'proveedor',
      'filtroFechaDocumentos',
      'sortByDescending'
    ]),
    titulo() {
      if ((/true/i).test(this.impuestos)) {
        return 'Registro de Pagos de Impuestos';
      }
      return 'Registro de Órdenes de Pago';
    },
    tableClass() {
      if ((/true/i).test(this.impuestos)) {
        return 'registro registro-pagos-impuestos';
      }
      return 'registro registro-pagos';
    },
    labelAnular() {
      if ((/true/i).test(this.impuestos)) {
        return 'Anular pago';
      }
      return 'Anular orden de pago';
    },
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    if ((/true/i).test(this.impuestos)) {
      this.pagosFields = [
        { key: 'fechaRegistro' },
        { 
          key: 'impuestoOrganismo',
          label: 'Organismo'
        },
        { 
          key: 'proveedor',
          label: 'Impuesto'
        },
        {
          key: 'total',
          class: 'text-right'
        },
        {
          key: 'saldo',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ]
    }

    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.proveedor = filtro.proveedor;
      this.filtroFechaDocumentos = filtro.filtroFechaDocumentos;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('pagos/getPagos', this.impuestos)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      if ((/true/i).test(this.impuestos)) {
        this.$router.push({ name: 'PagoImpuestosABM', 
                            params: { id: 0 }});
      } else {
        this.$router.push({ name: 'PagoABM', 
                            params: { id: 0 }});
      }
    },
    consultar (item) {
      if ((/true/i).test(this.impuestos)) {
        this.$router.push({ name: 'PagoImpuestosData', 
                            params: { id: item.id }});
      } else {
        this.$router.push({ name: 'PagoData', 
                            params: { id: item.id }});
      }
    },
    borrarItem (item) {
      let mensaje = '¿Desea anular la orden de pago seleccionada?';
      if ((/true/i).test(this.impuestos)) {
        mensaje = '¿Desea anular el pago de impuestos seleccionado?';
      }

      this.showModalConfirm(mensaje, this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (pagoId) {
      let mensaje = 'La orden de pago se anuló con éxito';
      if ((/true/i).test(this.impuestos)) {
        mensaje = 'El pago de impuestos se anuló con éxito';
      }

      this.showSpinner();
      this.$store.dispatch('pagos/delete', pagoId)
        .then(() => this.showModalMsj(mensaje, this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarListado() {
      this.showSpinner();
      this.$store.dispatch('pagos/getList')
        .then(() => {
          let exportar = false; 
          let list = this.$store.getters['pagos/list'];
          
          if (list) {
            if (list != 0) {
              exportar = true;
            }
          }

          if (exportar) {
            let title= 'Listado de Órdenes';
            let fileName = 'ordenes-pago';
            if (this.impuestos) {
              fileName = 'ordenes-pago-impuestos';
            }
            let format = [
              { titulo: 'Nro.Orden', nombre: 'id', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Fecha Contable', nombre: 'fechaContable', formato: 'fecha' }
            ];
    
            if (this.impuestos) {
              format.push(
                { titulo: 'Organismo', nombre: 'impuestoOrganismo', formato: '' },
                { titulo: 'Impuesto', nombre: 'proveedor', formato: '' }
              )
            } else {
              format.push(
                { titulo: 'Proveedor', nombre: 'proveedor', formato: '' }
              )
            }

            format.push(
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total', nombre: 'total', formato: '' },
              { titulo: 'Saldo', nombre: 'saldo', formato: '' }
            )
    
            this.exportXLS(title, fileName, list, format);
          } else {
            this.showModalMsj ('No hay datos para exportar.', null, null, 'danger');
          }

        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  /* Pagos */
  .registro-pagos table td[aria-colindex="1"] {
    width: 10%;
  }
  .registro-pagos table td[aria-colindex="2"],
  .registro-pagos table td[aria-colindex="3"] {
    width: 10%;
  }
  .registro-pagos table td[aria-colindex="4"] {
    width: Calc(50% - 30px);
  }
  .registro-pagos table td[aria-colindex="5"],
  .registro-pagos table td[aria-colindex="6"] {
    width: 10%;
  }
  .registro-pagos table td[aria-colindex="7"] {
    width: 30px;
  }

  /* Pagos - Impuestos */
  .registro-pagos-impuestos table td[aria-colindex="1"] {
    width: 10%;
  }
  .registro-pagos-impuestos table td[aria-colindex="2"],
  .registro-pagos-impuestos table td[aria-colindex="3"] {
    width: Calc(35% - 15px);
  }
  .registro-pagos-impuestos table td[aria-colindex="4"],
  .registro-pagos-impuestos table td[aria-colindex="5"] {
    width: 10%;
  }
  .registro-pagos-impuestos table td[aria-colindex="6"] {
    width: 30px;
  }
</style>
